fieldset
  label Nach
  select(name="target").select-plain.pure-input-1
    each target in collection.models
      option(value=target.id, selected=model.targetId === target.id) #{target.name}
